<template>
  <section>
    <!-- Componentes externos VACACIONES PROGRAMADAS Y REPROGRAMADAS-->

    <VerDetalleUsoVacacion />
    <VerDetalle />
    <VerReporte />
    <VerReprogramaciones />
    <AprobarReprogramacionRRHH />
    <AprobarUsoRRHH />
    <ReprogramarCronograma />
    <RechazarReprogramacionJefe />
    <EditarReprogramacionRechazada />
    <EditarReprogramacionRechazadaRRHH />
    <SolicitarEjecucionVacacion />
    <VolverEstadoInicialProgramacion />
    <!-- Componentes externos PAPELETAS CON CARGO A VACACION-->
    <VerPermiso />
    <AnularPermiso />
    <AprobarRRHHSinPermisos />
    <EditarPermisoCargoVacacion />
    <RechazarPermisoRRHH />
    <CrearPermisoCargoVacacion />

    <CabeceraDuodecima/>
    <VerReportePapeletaV />
    <VerDocumento />
    <v-layout row wrap>
      <v-flex shrink>
        <v-btn icon color="primary" :to="`/vacaciones/rrhh`">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs10>
        <h3 class="primary--text">
          <v-icon color="primary">today</v-icon> Vacaciones programadas
        </h3>
      </v-flex>
      <v-flex xs12 md12>
        <h4 style="color: #000">
          <b>NOMBRE COMPLETO   :</b>  {{ nombres }}
        </h4>
      </v-flex>
      <!-- Seleccionar gestion-->
      <v-flex xs6 md6>
        <v-autocomplete
          class="text-field-reducido-border"
          :items="lista_gestiones"
          item-text="periodo"
          item-value="periodo"
          label="Seleccione la gestión"
          v-model="periodo_seleccionado"
          @input="cargarVacacionesProgramadas(periodo_seleccionado)"
          required
          outline
          success
          clearable
        ></v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row wrap>  
      <v-flex shrink>
        <!-- Nueva papeleta con cargo a  vacacion-->
        <v-tooltip bottom>
          <v-btn
            color="primary"
            slot="activator"
            @click="crearPermisoCargoVacacion()"
            ><v-icon>event_note</v-icon> Nueva Solicitud
          </v-btn>
          <span>Nueva solicitud con cargo a vacación</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink>
        <!-- Nueva papeleta con cargoa  vacacion-->
        <v-tooltip bottom>
          <v-btn
            dark
            color="rgb(87,51,204)"
            slot="activator"
            @click="cabeceraDuodecima({})"
            ><v-icon>add</v-icon> Ver duodécimas
          </v-btn>
          <span>Ver duodécima</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink>
     
      </v-flex>
     
    </v-layout>

    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarVacacionesProgramadas(periodo_seleccionado)"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <!-- Filtros-->
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container-rrhh" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>
          <div class="filter-item">
            <v-text-field
              label="Nro"
              v-model="form.numero"
              @input="filterNumero"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha desde"
              type="date"
              v-model="form.fecha_desde"
              @input="filterFechaDesde"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha hasta"
              type="date"
              v-model="form.fecha_hasta"
              @input="filterFechaHasta"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Días programados"
              type="number"
              v-model="form.dias"
              @input="filterDias"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Tipo"
              type="text"
              v-model="form.tipo"
              @input="filterTipo"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              v-model="form.estado"
              @input="filterEstado"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha solicitud"
              type="date"
              v-model="form.fecha_solicitud"
              @input="filterFechaSolicitud"
            ></v-text-field>
          </div>
          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                  }
                "
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :items="lista_vacaciones"
          :headers="headers"
          :disable-initial-sort="true"
          item-key="numero"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon v-if="header.value" small color="white"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <tr
              :class="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <td class="text-xs-center py-0 px-1">{{ items.item.numero }}</td>
              <td class="text-xs-center py-0 px-1">
                {{ items.item.fecha_desde }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ items.item.fecha_hasta }}
              </td>
              <td class="text-xs-center py-0 px-1">{{ items.item.dias }}</td>
              <td class="text-xs-center py-0 px-1">{{ items.item.tipo }}</td>
              <td class="text-xs-center py-0 px-1">
                {{
                  items.item.id_estado == 70
                    ? "Reprogramado Aprobado"
                    : items.item.id_estado == 7
                    ? "Aprobada Inmediato Superior"
                    : items.item.estado
                    ? items.item.estado
                    : ""
                }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{
                  items.item.jefe_enviado &&
                  (items.item.id_estado == 55 ||
                    items.item.id_estado == 58 ||
                    items.item.id_estado == 68 ||
                    items.item.id_estado == 69 ||
                    items.item.id_estado == 6 ||
                    items.item.id_estado == 7)
                    ? items.item.jefe_enviado
                    : ""
                }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ items.item.fecha_solicitud }}
              </td>
              <td class="text-xs-center py-0 px-1">
                {{ items.item.justificacion_rechazo }}
              </td>

              <td class="text-xs-center py-0 px-1">
                <v-chip
                  class="chip-multilinea"
                  :color="
                    items.item.dias_faltantes > 0 &&
                    items.item.tipo != 'FR' &&
                    items.item.tipo != 'VC'
                      ? '#00D092'
                      : items.item.dias_faltantes < 0 &&
                        items.item.id_estado != 57 &&
                        items.item.id_estado != 65 &&
                        items.item.tipo != 'FR' &&
                        items.item.tipo != 'VC'
                      ? '#d6232e'
                      : items.item.dias_faltantes == 0 &&
                        items.item.tipo != 'FR' &&
                        items.item.tipo != 'VC'
                      ? '#00D092'
                      : ''
                  "
                  text-color="white"
                >
                  {{
                    items.item.dias_faltantes > 0 &&
                    items.item.tipo != "FR" &&
                    items.item.tipo != "VC"
                      ? `Falta ${items.item.dias_faltantes} días para hacer uso de su vacación`
                      : items.item.dias_faltantes < 0 &&
                        items.item.id_estado != 57 &&
                        items.item.id_estado != 65 &&
                        items.item.tipo != "FR" &&
                        items.item.tipo != "VC"
                      ? `Programación vencida`
                      : items.item.dias_faltantes == 0 &&
                        items.item.tipo != "FR" &&
                        items.item.tipo != "VC"
                      ? `Hoy es la fecha del uso de su vacación`
                      : ""
                  }}
                </v-chip>
              </td>
              <td class="text-xs-center py-0 px-1">
                <v-tooltip bottom>
                  <v-checkbox
                    slot="activator"
                    v-if="items.item.id_estado != 82"
                    v-model="items.item.entregado"
                    primary
                    hide-details
                    @change="documentoEntregado(items.item)"
                  ></v-checkbox>
                  <span>{{
                    items.item.entregado ? "Desmarcar" : "Marcar"
                  }}</span>
                </v-tooltip>
              </td>
              <!-- -------------------------------------------- VACACIONES REPROGRAMADAS Y PROGRAMADAS BOTONES ---------------------------------------------->
              <td
                v-if="
                  items.item.tipo == 'P' ||
                    items.item.tipo == 'R' ||
                    items.item.tipo == 'FR'
                "
                class="py-0 px-1 btn-comprimido"
              >
                <!-- ver detalle de la programacion -->
                <v-btn
                  color="#3dca24"
                  @click.prevent="verDetalle(items.item)"
                  icon
                  dark
                  title="Ver detalle"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <!-- EJECUCION DE LA VACACION-->
                <!-- <v-btn
                  v-if="
                  (items.item.id_estado == 72 || items.item.id_estado == 70)"
                color="#44deaa"
                @click.prevent="solicitarEjecucionVacacion(items.item)"
                icon
                title="Enviar solicitud de uso de vacación"
              >
                <v-icon>send</v-icon>
              </v-btn> -->
                <!-- VACACIONES REPROGRAMADAS-->
                <!-- <v-btn
                v-if="items.item.id_estado == 57"
                color="#44deaa"
                @click.prevent="verReprogramaciones(items.item)"
                icon
                title="Ver detalle de reprogramaciones"
              >
                <v-icon>today</v-icon>
              </v-btn> -->

                <!-- APROBACION DE LA VACACION-->
                <v-btn
                  v-if="
                    items.item.id_estado == 55 ||
                      items.item.id_estado == 72 ||
                      items.item.id_estado == 58 ||
                      items.item.id_estado == 70
                  "
                  color="rgb(147,13,242)"
                  dark
                  @click.prevent="aprobarUsoRRHH(items.item)"
                  icon
                  title="Aprobar uso de vacación"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <!-- APROBACION DE LA VACACION REPROGRAMADA-->
                <v-btn
                  v-if="
                    items.item.id_estado_hijo == 68 ||
                      items.item.id_estado_hijo == 69
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="aprobarReprogramacionRRHH(items.item)"
                  icon
                  dark
                  title="Aprobar reprogramación"
                >
                  <v-icon>done</v-icon>
                </v-btn>

                <!-- RETROCEDER A ESTADO INICIAL EL USO DE VACACION - ya no se usara -->
                <!-- <v-btn
                v-if="items.item.id_estado == 55 || items.item.id_estado == 58"
                color="rgb(242,175,13)"
                @click.prevent="retrocederUsoVacacion(items.item)"
                icon
                title="Volver a estado inicial"
              >
                <v-icon>reply</v-icon>
              </v-btn> -->
                <!-- RETROCEDER A ESTADO INICIAL LA REPROGRAMACION  v-if="
                  (items.item.id_estado == 57 || items.item.id_estado == 71) &&
                  (items.item.id_estado_hijo == 68 ||
                    items.item.id_estado_hijo == 69 ||
                    items.item.id_estado_hijo == 71)
                "-->
                <!-- Reprogramar-->
                <v-btn
                  v-if="
                    items.item.id_estado == 72 ||
                      items.item.id_estado == 71 ||
                      items.item.id_estado == 56
                  "
                  color="rgb(242,94,13)"
                  @click.prevent="editarReprogramacionRechazada(items.item)"
                  icon
                  dark
                  title="Reprogramar"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <!-- EDITAR LA REPROGRAMACION,CONSERVANDO CORRELATIVOS-->
                <v-btn
                  v-if="[57, 71].includes(parseInt(items.item.id_estado))"
                  color="#4169e1"
                  @click.prevent="EditarReprogConCorrelativo(items.item)"
                  icon
                  dark
                  title="Editar reprogramación"
                >
                  <v-icon>edit</v-icon>
                </v-btn>

                <!-- Rechazar la reprogramacion-->
                <v-btn
                  v-if="
                    items.item.id_estado == 57 &&
                      (items.item.id_estado_hijo == 68 ||
                        items.item.id_estado_hijo == 69)
                  "
                  color="#FF5D34"
                  @click.prevent="rechazarReprogramacion(items.item)"
                  icon
                  dark
                  title="Rechazar reprogramación"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <!-- <v-btn
                v-if="
                  (items.item.id_estado_hijo &&
                    (items.item.id_estado_hijo == 68 ||
                      items.item.id_estado_hijo == 69)) ||
                  (items.item.id_estado == 57 &&
                    (items.item.tipo == 'R' || items.item.tipo == 'FR') &&
                    items.item.id_estado_hijo != 65 &&
                    items.item.id_estado_hijo != 58 &&
                    items.item.id_estado_hijo != 55)
                "
                color="#FF5D34"
                @click.prevent="rechazarReprogramacion(items.item)"
                icon
                title="Rechazar reprogramación .."
              >
                <v-icon>close</v-icon>
              </v-btn> -->
                <!-- Volver a estado inicial la programacion-->
                <v-btn
                  v-if="
                    items.item.id_estado == 55 || items.item.id_estado == 58
                  "
                  color="rgb(255,179,0)"
                  @click.prevent="retrocederProgVacacion(items.item)"
                  icon
                  dark
                  title="Volver a estado inicial ---"
                >
                  <v-icon>reply</v-icon>
                </v-btn>
                <!-- Volver a estado inicial la programacion y devolver gestiones-->
                <v-btn
                  v-if="
                    items.item.id_estado == 65 &&
                      items.item.id_padre == null &&
                      items.item.tipo == 'P'
                  "
                  color="rgb(255,179,0)"
                  @click.prevent="volverEstadoInicialProgramacion(items.item)"
                  icon
                  dark
                  title="Volver a estado inicial"
                >
                  <v-icon>reply</v-icon>
                </v-btn>
                <!-- Volver a estado inicial la reprogramacion
                v-if="
                    items.item.id_estado == 57 &&
                      (items.item.id_estado_hijo == 68 ||
                        items.item.id_estado_hijo == 69)
                  "
                  Excluimos los estados 55, 58 y 65 ya que estan en proceso de uso
                -->
                <v-btn
                  v-if="
                    items.item.id_estado == 57 &&
                      !items.item.estados_hijos
                        .split(',')
                        .map(ele => parseInt(ele))
                        .includes(55) &&
                      !items.item.estados_hijos
                        .split(',')
                        .map(ele => parseInt(ele))
                        .includes(58) &&
                      !items.item.estados_hijos
                        .split(',')
                        .map(ele => parseInt(ele))
                        .includes(65)
                  "
                  color="rgb(145,26,230)"
                  @click.prevent="retrocederReprogVacacion(items.item)"
                  icon
                  dark
                  title="Volver a estado inicial"
                >
                  <v-icon>reply</v-icon>
                </v-btn>

                <!-- Reporte de programación -->
                <v-btn
                  v-if="
                    (items.item.id_estado == 65 ||
                      items.item.id_estado == 55 ||
                      items.item.id_estado == 58) &&
                      items.item.tipo == 'P'
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="verReporte(items.item, 0)"
                  icon
                  dark
                  title="Ver reporte de programación de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
                <!-- Reporte de reprogramación -->
                <v-btn
                  v-if="
                    items.item.id_estado == 57 &&
                      (items.item.id_estado_hijo == 70 ||
                        items.item.id_estado_hijo == 55 ||
                        items.item.id_estado_hijo == 58 ||
                        items.item.id_estado_hijo == 65 ||
                        items.item.id_estado_hijo == 68 ||
                        items.item.id_estado_hijo == 69)
                  "
                  color="rgba( 142, 68, 173 ,0.7)"
                  @click.prevent="verReporte(items.item, 2)"
                  icon
                  dark
                  title="Ver reporte de reprogramación de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    items.item.id_estado != 65 && items.item.id_estado != 57
                  "
                  color="rgb(230,26,26)"
                  @click.prevent="anularCronograma(items.item, 1)"
                  icon
                  dark
                  title="Anular programación"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    (items.item.id_estado == 65 ||
                      items.item.id_estado == 55 ||
                      items.item.id_estado == 58) &&
                      items.item.tipo == 'R'
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="verReporte(items.item, 1)"
                  icon
                  dark
                  title="Ver reporte de reprogramación de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </td>
              <!-- ------------------------------------------------- BOTONES PAPELETAS CON CARGO A VACACION---------------------------------------------->
              <td v-if="items.item.tipo == 'VC'" class="btn-comprimido">
                <v-btn
                  color="info"
                  dark
                  @click.prevent="verPermiso(items.item)"
                  icon
                  title="Ver permiso"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  color="warning"
                  v-if="items.item.id_estado == 22"
                  @click.prevent="editarPermisoCargoVacacion(items.item)"
                  icon
                  title="Modificar"
                >
                  <v-icon>edit</v-icon>
                </v-btn>

                <v-btn
                  color="red"
                  v-if="items.item.id_estado == 22"
                  @click.prevent="anularPermiso(items.item)"
                  icon
                  title="Anular"
                  dark
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <!-- Reporte de programación -->
                <v-btn
                  v-if="
                    items.item.id_estado == 6 ||
                      items.item.id_estado == 77 ||
                      items.item.id_estado == 7 ||
                      items.item.id_estado == 75 ||
                      items.item.id_estado == 21
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="verReportePapeletaV(items.item)"
                  icon
                  dark
                  title="Ver reporte papeleta con cargo a vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
                <!-- ---------SUPER APROBACION------ -->
                <v-tooltip bottom>
                  <v-btn
                    v-if="
                      items.item.id_estado == 22 ||
                        items.item.id_estado == 21 ||
                        items.item.id_estado == 7 ||
                        items.item.id_estado == 6
                    "
                    color="warning"
                    icon
                    slot="activator"
                    @click.prevent="aprobarRRHHSinPermisos(items.item)"
                  >
                    <v-icon>done_all</v-icon>
                  </v-btn>

                  <span>Aprobar vacación</span>
                </v-tooltip>
                <v-btn
                  :color="
                    [75, 77].includes(parseInt(items.item.id_estado))
                      ? 'rgb(145,26,230)'
                      : '#E61C5B'
                  "
                  v-if="
                    [6, 22, 7, 75, 77].includes(parseInt(items.item.id_estado))
                  "
                  @click.prevent="rechazarPermisoRRHH(items.item)"
                  icon
                  dark
                  :title="
                    [75, 77].includes(parseInt(items.item.id_estado))
                      ? 'Volver a estado inicial'
                      : 'Rechazar'
                  "
                >
                  <v-icon>{{
                    [75, 77].includes(parseInt(items.item.id_estado))
                      ? "reply"
                      : "close"
                  }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
//VACACIONES PROGRAMADAS Y REPROGRAMADAS
import CrudTable from "@/common/util/crud-table-sin-orden/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table-sin-orden/mixins/crud-table"; // Funciones y Metodos
import AprobarReprogramacionRRHH from "./dialogs/AprobarReprogramacionRRHH.vue";
import AprobarUsoRRHH from "./dialogs/AprobarUsoRRHH.vue";
import VerDetalleUsoVacacion from "./dialogs/VerDetalleUsoVacacion.vue";
import VerDetalle from "./dialogs/VerDetalle.vue";
import VerReporte from "../vacacion_uso/dialogs/VerReporte";
import VerReprogramaciones from "../vacacion_uso/dialogs/VerReprogramaciones";
import ReprogramarCronograma from "./dialogs/ReprogramarCronograma.vue";
import RechazarReprogramacionJefe from "../vacacion_uso/dialogs/RechazarReprogramacionJefe.vue";
import EditarReprogramacionRechazada from "../vacacion_uso/dialogs/EditarReprogramacionRechazada.vue";
import EditarReprogramacionRechazadaRRHH from "./dialogs/EditarReprogramacionRRHH.vue";
import SolicitarEjecucionVacacion from "../vacacion_uso/dialogs/SolicitarEjecucionVacacion.vue";
import VolverEstadoInicialProgramacion from "./dialogs/VolverEstadoInicialProgramacion.vue";
//PAPELETAS CON CARGO A VACACION
import VerPermiso from "./dialogs/VerPermiso.vue";
import EditarPermisoCargoVacacion from "./dialogs/EditarPermisoCargoVacacion.vue";
import RechazarPermisoRRHH from "./dialogs/RechazarPermisoRRHH";
import AprobarRRHHSinPermisos from "./dialogs/AprobarRRHHSinPermisos";
import AnularPermiso from "./dialogs/AnularPermiso.vue";
import CrearPermisoCargoVacacion from "./dialogs/CrearPermisoCargoVacacion.vue";
import VerReportePapeletaV from "../permiso/dialogs/VerReporte.vue";
//duodecimas:
import CabeceraDuodecima from "./dialogs/CabeceraDuodecima.vue";
import VerDuodecima from "./dialogs/CabeceraDuodecima.vue";

//FILTROS

import FiltrosVacacion from "./mixins/FiltrosVacacion";
import VolverEstadoInicialReprogramacion from "./dialogs/VolverEstadoInicialReprogramacion.vue";

// Ver documento
import VerDocumento from "../permiso/dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, FiltrosVacacion],
  // Variables iniciales del componente
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      lista_vacaciones: [],
      loading: false,
      user: this.$storage.get("user"),
      total_vacacion_disponible: 0,
      // Variables filtros
      filterShow: true,
      nombres: null,
      datos: [],
      lista_gestiones: [],
      lista_duodecimas: [],
      tipo_duodecima:null,
      id_persona: this.$route.params.id_persona,
      periodo_seleccionado: new Date().getFullYear(),
      form: {},
      filters: {
        numero: "",
        fecha_desde: "",
        fecha_hasta: "",
        dias: "",
        tipo: "",
        estado: "",
        fecha_solicitud: "",
        nombre_unidad: "",
        nombres: ""
      },
      form: {},
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        {
          text: "Nro",
          value: "numero",
          align: "center"
        },

        { text: "Fecha desde", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        { text: "Días programados", value: "dias", align: "center" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Solicitud enviada a", value: "", align: "center" },
        {
          text: "Fecha de solicitud",
          value: "fecha_solicitud",
          align: "center"
        },
        {
          text: "Justificación",
          value: "justificacion_rechazo",
          align: "center"
        },
        { text: "Notificación", value: "", align: "center" },
        { text: "Entregado", sortable: false, align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() { 
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [76, 32]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/accion-no-permitida");
    }
    await this.obtenerListaGestiones();
    await this.obtenerListaDuodecimas();
    await this.cargarVacacionesProgramadas(this.periodo_seleccionado);

    await this.obtenerSaldoVacacionesPapeletas();
    //vacaciones programadas y reprogramadas 
    this.$bus.$on("closeDialogVerReporteCronograma", async () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioRRHH", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioNormalRRHH", () => {});
    this.$bus.$on("closeDialogVerReprogramaciones", () => {});
    this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogEditarReprogramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogVolverEstadoInicialProgramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogEditarReprogramacionRRHH", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogReprogramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogReprogramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogAprobarReprogramacionRRHH", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogAprobarUsoRRHH", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    //papeletas con cargo a vacacion
    this.$bus.$on("closeDialogVerReportePermiso", async () => {});
    this.$bus.$on("closeDialogVerPermisoRRHH", async () => {});
    this.$bus.$on("closeDialogAnularPapeletaRRHH", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogRechazarRRHHPapeleta", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogAprobarRRHHSinPermisosPapeleta", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogCrearPapeletaVacacionRRHH", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas()
    });
    this.$bus.$on("closeDialogRechazarReprogramacionJefe", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogPapVaccaionRRHHEdit", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogCabeceraDuodecima", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
    this.$bus.$on("closeDialogVerDuodecima", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
      await this.obtenerSaldoVacacionesPapeletas();
    });
  },
  // Métodos y funciones del componente
  methods: {
    //anular programacion de vacaciones
    async anularCronograma(item) {
      try {
        let rpta = null;
        let user = this.$storage.get("user");
        this.$confirm(
          "¿Esta seguro(a) de eliminar la programación?. Esta acción es irreversible",
          async () => {
            rpta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select vacaciones.fn_solicita_anula_vacacion_programada(${parseInt(
                  item.id_vacacion
                )},9,${user.id})"){
                  respuesta
                }
              }
              `
            });
            rpta = rpta.runQuery.respuesta[0].fn_solicita_anula_vacacion_programada.split(
              "|"
            );
            if (rpta[0] == "1") {
              this.$confirm(
                "La programación se elimino exitosamente",
                async () => {
                  await this.cargarVacacionesProgramadas(
                    this.periodo_seleccionado
                  );
                }
              );
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    //calcular duodecima:
    async calcularDuodecima(){
      try {//this.tipo_duodecima
        
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      try {
        this.lista_gestiones = [];
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select vev.periodo from vacaciones.v_estado_vacacion vev where vev.id_persona =${parseInt(
                    this.id_persona
                  )}"){
                  respuesta
                  }
                }	
          `
        });

        if (resp.runQuery.respuesta.length > 0) {
          this.lista_gestiones = resp.runQuery.respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    //obtener listado de duodecimas:
    async obtenerListaDuodecimas(){
      try {
        let resp = await this.$service.graphql({
          query: `
            query{
              params(tipo:"tipo_duodecima"){
                rows{
                  id
                  valor
                  tipo
                }
              }
            }
          `
        }).then(async (response) => {
            if (response) {
              this.lista_duodecimas = response.params.rows
            }
          });
      } catch (error) {
        console.log(error);
      }
    },

    solicitarEjecucionVacacion(item) {
      item.id_vacacion_programada = item.id_vacacion;
      this.$bus.$emit("openDialogSolicitarEjecucionVacacion", item);
    },
    //volver al estado 72 el uso de vacacion si no es reprogramacion, si es reprogramacion volver al estado 70(El seguimiento se eliminara de la tabla ,y se traslada a otra tabla: :historial_seguimiento_vacacion)
    async retrocederUsoVacacion(item) {
      try {
        this.$confirm(
          "¿Esta seguro(a) de volver a estado inicial?. Esta acción es irreversible."
          //funcion que vuelve a estado inicial el uso de vacacion:
        );
      } catch (error) {
        console.log(error);
      }
    },

    async EditarReprogConCorrelativo(item) {
      try {
        item.id_vacacion_programada = parseInt(item.id_vacacion);
        item.total_dias = parseInt(item.dias);
        this.$bus.$emit("openDialogEditarReprogramacionRRHH", item);
      } catch (error) {
        console.log(error);
      }
    },

    async documentoEntregado(dato) {
      try {
        let estado_entregado = "N";
        let mensaje = "¿Desea marcar como No Entregado?";
        if (dato.entregado == true) {
          estado_entregado = "S";
          mensaje = "¿Desea marcar como entregado?";
        }
        let user = this.$storage.get("user");
        this.$confirm(
          mensaje,
          async () => {
            let respuesta;
            if (dato.tipo == "VC") {
              respuesta = await this.$service.graphql({
                query: `
              query{ 
                  runQuery(consulta:"select control.fn_papeleta_permiso_entregado(${dato.id_vacacion},${user.id},'${estado_entregado}')"){
                  respuesta
                  }
                }	

              `
              });
              let resp =
                respuesta.runQuery.respuesta[0].fn_papeleta_permiso_entregado;
              if (resp.split("|"[0]) == "1") {
                await this.cargarVacacionesProgramadas(
                  this.periodo_seleccionado
                );
              }
            } else {
              respuesta = await this.$service.graphql({
                query: `
                query{ 
                  runQuery(consulta:"select vacaciones.fn_papeleta_vacaciones_entregado(${dato.id_vacacion},${user.id},'${estado_entregado}')"){
                  respuesta
                  }
                }	
              `
              });
              let resp =
                respuesta.runQuery.respuesta[0]
                  .fn_papeleta_vacaciones_entregado;
              if (resp.split("|"[0]) == "1") {
                await this.cargarVacacionesProgramadas(
                  this.periodo_seleccionado
                );
              }
            }
          },
          () => {
            dato.entregado = dato.entregado ? false : true;
          }
        );
      } catch (error) {
        console.log(error);
      }
    },

    // Metodo para listar la tabla
    async cargarVacacionesProgramadas(periodo) {
      try {
        if (!periodo) {
          return;
        }
        this.loading = true;
        this.lista_vacaciones = [];
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select vvp.*,case WHEN vvp.entregado like 'N' THEN false ::boolean WHEN vvp.entregado like 'S' THEN true ::boolean end entregado FROM vacaciones.v_vac_programacion_reprogramacion_a_cuenta_vacacion_para_rrhh vvp WHERE vvp.id_persona=${parseInt(
                    this.id_persona
                  )} and vvp.gestion =${parseInt(
            periodo
          )} and (vvp.id_estado not in (51,73,66,54,67,68,69,71) or(vvp.id_estado=71 and vvp.tipo='FR')) "){
                  respuesta
                  }
                }	
          `
        });

        if (resp.runQuery.respuesta.length > 0) {
          let lista_tmp = resp.runQuery.respuesta;

          // Ordenamos la lista
          // Separamos negativos y positivos
          var lista_nega = [];
          var lista_posi = [];
          lista_tmp.forEach(element => {
            element.rol = 4;
            if (element.dias_faltantes < 0) {
              lista_nega.push(element);
            } else {
              lista_posi.push(element);
            }
          });
          // Ordenamos lista nega descendentemente
          lista_nega.sort(function(a, b) {
            if (a.dias_faltantes < b.dias_faltantes) {
              return 1;
            }
            if (a.dias_faltantes > b.dias_faltantes) {
              return -1;
            }
            return 0;
          });
          // Ordenamos lista posi ascendentemente
          lista_posi.sort(function(a, b) {
            if (a.dias_faltantes > b.dias_faltantes) {
              return 1;
            }
            if (a.dias_faltantes < b.dias_faltantes) {
              return -1;
            }
            return 0;
          });
          // unimos listas
          this.lista_vacaciones = lista_posi.concat(lista_nega);
        }
        //cargar nombre de la persona
        let nombre = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select * FROM persona.persona vvp WHERE vvp.id=${parseInt(
                    this.id_persona
                  )} and vvp.id_estado=1"){
                  respuesta
                  }
                }	
          `
        });

        if (nombre.runQuery.respuesta.length > 0) {
          let nombre_completo = nombre.runQuery.respuesta[0];

          this.nombres =
            nombre_completo.nombres +
            " " +
            nombre_completo.ap_paterno +
            " " +
            nombre_completo.ap_materno;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    //-------------------------------------------------------FUNCIONES VACACIONES PROGRAMADAS Y REPROGRAMADAS ---------------------------------------------------------
    reprogramarCronograma(item) {
      item.rol = 4;
      item.nombre = this.nombres;
      this.$bus.$emit("openDialogReprogramarCronograma", item);
    },
    // Metodo para volver a esta inicial 72
    volverEstadoInicialProgramacion(item) {
      this.$bus.$emit("openDialogVolverEstadoInicialProgramacion", item);
    },
    //Volver a estado 72 la vacacion solicitada
    async retrocederProgVacacion(item) {
      try {
        let rpta = "";
        this.$confirm(
          "¿Esta seguro(a) de volver a estado inicial?.",
          async () => {
            rpta = await this.$service.graphql({
              query: `
                query{
                runQuery(consulta:"select vacaciones.fn_restablece_vacacion_estado_inicial(${parseInt(
                  item.id_vacacion
                )},${parseInt(this.user.id)},'',null)"){
                  respuesta
                }
              }
              `
            });
            rpta = rpta.runQuery.respuesta[0].fn_restablece_vacacion_estado_inicial.split(
              "|"
            );
            if (rpta[0] == "1") {
              //cambiar el estado de la vacaion inicial
              //crear funcion
              this.$confirm(
                "La programación ya se encuentra en estado inicial",
                async () => {
                  await this.cargarVacacionesProgramadas(
                    this.periodo_seleccionado
                  );
                }
              );
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },

    //volver al estado 72 la programacion inicial , y eliminar a las reprogramaciones que nacieron a partir de este (las reprogramaciones eliminadas se traslada a otra tabla :historial_vacacion_programada)
    async retrocederReprogVacacion(dato) {
      try {
        let rpta = "";
        this.$confirm(
          "¿Esta seguro(a) de volver a estado inicial?. Se eliminaran todas las reprogramaciones creadas a partir de esta programacion.",
          async () => {
            //eliminar fisicamente antiguas reprogramaciones
            rpta = await this.$service.graphql({
              query: `
                query{
                runQuery(consulta:"select vacaciones.fn_retroceder_estado_inicial_vac_rep(${parseInt(
                  dato.id_vacacion
                )},${parseInt(this.user.id)})"){
                  respuesta
                }
              }
              `
            });
            rpta = rpta.runQuery.respuesta[0].fn_retroceder_estado_inicial_vac_rep.split(
              "|"
            );
            if (rpta[0] == "1") {
              //cambiar el estado de la vacaion inicial
              //crear funcion
              this.$alert(
                "La programación ya se encuentra en estado inicial",
                async () => {
                  await this.cargarVacacionesProgramadas(
                    this.periodo_seleccionado
                  );
                }
              );
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item, valor) {
      item.reprogramacion = valor; //programacion=0,repro=1
      item.id_vacacion_programada = item.id_vacacion;
      item.correlativo = item.numero;
      item.gestion = item.fecha_desde.substring(6, 10);
      // if (valor == 1 && item.tipo == "R") {
      //   item.id_vacacion_programada = item.id_vacacion;
      // }
      // if (valor == 1 && item.tipo == "FR") {
      //   item.id_vacacion_programada = item.id_vacacion;
      // }
      // if (valor == 0 && (item.tipo == "P" || item.tipo == "R")) {
      //   item.id_vacacion_programada = item.id_vacacion;
      // }

      this.$bus.$emit("openDialogVerReporte", item);
    },
    verReportePapeletaV(item) {
      item.id_tipo_permiso = 24;
      item.id_permiso = parseInt(item.id_vacacion);
      this.$bus.$emit("openDialogVerReportePermiso", item);
    },
    verReprogramaciones(item) {
      this.$bus.$emit("openDialogVerReprogramaciones", item);
    },
    aprobarUsoRRHH(item) {
      this.$bus.$emit("openDialogAprobarUsoRRHH", item);
    },
    aprobarReprogramacionRRHH(item) {
      this.$bus.$emit("openDialogAprobarReprogramacionRRHH", item);
    },
    reprogramarCronograma(item) {
      this.$bus.$emit("openDialogReprogramarCronograma", item);
    },
    verDetalle(item) {
      if (item.tipo == "P") {
        this.$bus.$emit("openDialogVerDetalleUsoVacacionRRHH", item);
      } else {
        this.$bus.$emit("openDialogVerDetalleUsoFuncionarioNormalRRHH", item);
      }
    },
    rechazarReprogramacion(item) {
      this.$bus.$emit("openDialogRechazarReprogramacionJefe", item);
    },
    editarReprogramacionRechazada(item) {
      item.rol = 4;
      item.id_vacacion_programada = parseInt(item.id_vacacion);
      item.total_dias = parseInt(item.dias);
      // item.id_padre=parseInt()
      this.$bus.$emit("openDialogEditarReprogramacion", item);
    },
    //-------------------------------------------------------FUNCIONES PAPELETAS CON CARGO A VACACION ---------------------------------------------------------
    verPermiso(item) {
      this.$bus.$emit("openDialogVerPermisoRRHH", item);
    },
    editarPermisoCargoVacacion(item) {
      item.rol = 4;
      item.es_funcionario = false;
      item.id_persona = this.id_persona;
      this.$bus.$emit("openDialogEditarPermisoCargoVacacion", item);
    },
    aprobarRRHHSinPermisos(item) {
      this.$bus.$emit("openDialogAprobarRRHHSinPermisosPapeleta", item);
    },
    anularPermiso(item) {
      this.$bus.$emit("openDialogAnularPermisoRRHH", item);
    },
    rechazarPermisoRRHH(item) {
      this.$bus.$emit("openDialogRechazarPermisoRRHH", item);
    },
    async cabeceraDuodecima(item){ 
      item.id_persona=this.id_persona
      this.$bus.$emit("openDialogCabeceraDuodecima", item);
    },
    async verDuodecima(item){
      this.$bus.$emit("openDialogVerDuodecima", item);
    },
    async crearPermisoCargoVacacion() {
      let fecha = new Date();
      let gestion_vigente = fecha.getFullYear();
      let id_persona;
      let dato = {};
      dato.rol = 42;
      let fecha_permiso = this.$moment(new Date()).format("YYYY-MM-DD");
      let user = this.$storage.get("user");
      try {
        id_persona = this.id_persona;

        // asigna total de Vacaciones restantes ,incluye creados y aprobados

        let respuesta = await this.$service.graphql({
          query: `
          query{
                  runQuery(consulta:"select control.fn_calcula_dias_permiso_por_vacacion_aprobados(${gestion_vigente},${id_persona})"){
                  respuesta
                  }
                }	

              `
        });

        let resp =
          respuesta.runQuery.respuesta[0]
            .fn_calcula_dias_permiso_por_vacacion_aprobados;
        dato.id_persona = this.id_persona;
        dato.rol = 4;
        dato.saldo_no_programadas = this.total_vacacion_disponible ? this.total_vacacion_disponible:0;
        dato.total_vacaciones = resp ? parseFloat(resp):0
        //Verifica que tenga saldo de vacaciones
         if (this.total_vacacion_disponible > 0) {
           dato.saldo_no_programadas = this.total_vacacion_disponible;
           dato.total_vacaciones = parseFloat(resp);
           this.$bus.$emit("openDialogCrearPermisoCargoVacacion", dato);
         } else {
           this.$message.info(
             "Usted no dispone de días para realizar una papeleta de solicitud a cuenta de vacación en esta gestión"
           );
         }
        //this.$bus.$emit("openDialogCrearPermisoCargoVacacion", dato);
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerSaldoVacacionesPapeletas() {
      let saldo_total_para_papeleta = 0;
      let fecha = new Date();
      let gestion_vigente = fecha.getFullYear();
      let id_persona;
      let resp2;
      let user = this.$storage.get("user");
      try {
        let respuesta2 = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select vacaciones.fn_obtiene_dias_para_cuenta_vacacion(${
                    this.id_persona
                  },${parseInt(gestion_vigente)})"){
                  respuesta
                  }
                }	
              `
        });

        if (
          respuesta2.runQuery.respuesta[0]
            .fn_obtiene_dias_para_cuenta_vacacion != null &&
          respuesta2.runQuery.respuesta[0].fn_obtiene_dias_para_cuenta_vacacion
        ) {
          resp2 =
            respuesta2.runQuery.respuesta[0]
              .fn_obtiene_dias_para_cuenta_vacacion;
          let respu = resp2.split("|");
          if (parseFloat(respu[1]) > 0) {
            saldo_total_para_papeleta = parseFloat(respu[1]);
          } else {
            saldo_total_para_papeleta = 0;
          }
        }
        this.total_vacacion_disponible = saldo_total_para_papeleta;
      } catch (error) {
        console.log(error);
      }
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    AprobarReprogramacionRRHH,
    VerDetalleUsoVacacion,
    VerDetalle,
    AprobarUsoRRHH,
    VerReporte,
    VerReprogramaciones,
    ReprogramarCronograma,
    VerPermiso,
    EditarPermisoCargoVacacion,
    AprobarRRHHSinPermisos,
    AnularPermiso,
    RechazarPermisoRRHH,
    CrearPermisoCargoVacacion,
    RechazarReprogramacionJefe,
    EditarReprogramacionRechazada,
    EditarReprogramacionRechazadaRRHH,
    VerReportePapeletaV,
    SolicitarEjecucionVacacion,
    VolverEstadoInicialReprogramacion,
    VolverEstadoInicialProgramacion,
    VerDocumento,
    VerDuodecima,
    CabeceraDuodecima,
  }
};
</script>

<style lang="scss">
.celdaP {
  background: rgba(103, 236, 179, 0.3);
}
.celdaR {
  background: rgba(241, 217, 111, 0.3);
}
.celdaVC {
  background: rgba(189, 143, 238, 0.3);
}
.celdaFR {
  background: rgba(141, 208, 240, 0.3);
}
.chip-multilinea {
  .v-chip__content {
    height: auto;
    padding: 0.15rem 0.5rem;
    white-space: normal;
  }
}
.btn-comprimido {
  .v-btn {
    margin: 0.1rem 0rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/VacacionesProgramadasPorServidorRRHH.vue